import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NodeAabb } from '../../../r3f/components/NodeAabb';
import { AabbAxesGizmo } from '../../../r3f/components/AabbAxesGizmo';
import { PluginGizmo } from '../../../r3f/gizmo/PluginGizmo';
import { Node3D } from '../../base/node3d/Component';
/** `editors/3d_gizmos/gizmo_colors/visibility_notifier` (`editor_settings.cpp:895`). */
const GIZMO_COLOR = Object.freeze({ r: 0.8, g: 0.5, b: 0.7 });
/** The alpha of the solid material (`visible_on_screen_notifier_3d_gizmo_plugin.cpp:40`). */
const SOLID_ALPHA = 0.1;
export function VisibleOnScreenNotifier3D({ node, children }) {
    const { aabb } = node.properties;
    return (_jsxs(Node3D, { node: node, children: [_jsx(NodeAabb, { aabb: aabb }), _jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(AabbAxesGizmo, { aabb: aabb, color: GIZMO_COLOR, solidAlpha: SOLID_ALPHA }) }), children] }));
}
//# sourceMappingURL=Component.js.map